@if (product() && product().rating) {
<div
  style="display: flex; align-items: center; gap: 4px; color: black"
  [style.font-size]="size()"
>
  @if (compact()) {
  <mat-icon inline class="star-filled star-compact">star</mat-icon>
  } @else {
  <div style="position: relative; display: flex">
    @for (i of emptyStars(); track $index) {
    <mat-icon inline class="star-empty" style="margin: 0">star_border</mat-icon>
    }
    <div style="display: flex; position: absolute; top: 0; left: 0">
      @for (i of filledStars(); track $index) {
      <mat-icon inline class="star-filled" style="margin: 0">star</mat-icon>
      } @if (partialStarWidth() > 0) {
      <mat-icon
        inline
        class="star-filled"
        style="margin: 0;"
        [style.clip-path]="partialStarClipPath()"
      >
        star
      </mat-icon>
      }
    </div>
  </div>
  }
  <span style="font-size: smaller; color: #555"
    >{{ ratingLabel() }}
    {{ size() == "larger" ? countLabel() : "" }}</span
  >
</div>
}
